module.exports = __webpack_public_path__ + "static/login-bg-e83ee3496f127d370a043d08d1bcc19c.jpg";